import {
  colors,
  font_weight,
  layers,
  media,
  opacity,
  radius,
  spacing,
  Typography,
  typography,
} from '@lamimed/pantheon';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${rgba(colors.dark, opacity.hard)};
  z-index: ${layers.menu};
  cursor: pointer;
`;

export const Wrapper = styled.div`
  position: relative;
  margin-left: ${spacing.medium};
`;

export const Flag = styled.span`
  width: 2rem;
  height: 2rem;
  display: inline-block;
  margin-right: ${spacing.small};
  border-radius: 0.4rem;
  overflow: clip;
`;

export const Icon = styled.span<{ $isOpen?: boolean }>`
  ${({ $isOpen }) => css`
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    transform: translateY(-0.2rem);
    ${$isOpen &&
    css`
      rotate: 180deg;
    `}
  `}
`;

export const Picker = styled.span`
  ${typography.body_text_2};
  text-transform: uppercase;
  font-family: monospace;
  display: inline-flex;
  cursor: pointer;
  height: 2rem;
  align-items: center;
  line-height: 1;
  padding: 0.4rem;
  border-radius: 0.4rem;
  color: ${colors.neutral};
  ${Flag} {
    width: 1.6rem;
    height: 1.6rem;
  }
  ${Icon} {
    visibility: visible;
    color: ${colors.dark};
    margin-left: ${spacing.small};
  }
  ${media.greaterThan('tablet')`
    background-color: ${colors.neutral_extra_light};
  `}
`;

export const ListWrapper = styled.div<{ $isOpen: boolean }>`
  ${({ $isOpen }) => css`
    position: absolute;
    top: 100%;
    right: 0;
    z-index: ${layers.menu + 1};
    background-color: ${colors.light};
    border-radius: ${radius.small};
    padding: ${spacing.small};
    flex-direction: column;
    margin-top: ${spacing.medium};
    display: ${$isOpen ? 'flex' : 'none'};
    ${media.greaterThan('tablet')`
      margin-top: ${spacing.small};
      background-color: ${colors.neutral_extra_light};
      min-width: 18rem;
    `}
  `}
`;

export const Label = styled(Typography).attrs({
  variant: 'body_text_2',
})`
  font-weight: ${font_weight.medium};
  margin-bottom: ${spacing.medium};
  white-space: nowrap;
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const Item = styled.li<{ $isSelected: boolean }>`
  ${({ $isSelected }) => css`
    ${typography.body_text_2};
    align-items: center;
    border-radius: 0.4rem;
    color: ${colors.dark};
    cursor: pointer;
    display: flex;
    margin: 0;
    padding: 0.4rem;
    white-space: nowrap;
    ${media.greaterThan('tablet')`
      background-color: ${colors.neutral_extra_light};
    `}
    ${Icon} {
      visibility: hidden;
      margin-left: auto;
      margin-right: 0.6rem;
    }
    ${$isSelected &&
    css`
      background-color: ${colors.neutral_light};
      ${media.greaterThan('tablet')`
        background-color: ${colors.light};
      `}
      ${Icon} {
        visibility: visible;
      }
    `}
    &:not(:last-child) {
      margin-bottom: ${spacing.small};
    }
  `}
`;
